import { LoadRosterStructureParams, RosterStructureRepository } from '@softapps/pms/roster';
import { ApiDataAccess, ApiResourceLocation } from '@softline/core';
import { inject, Injectable } from '@angular/core';
import { Structure } from '@softapps/pms/roster';
import { SOFTLINE_API_GARAGE_ROSTER_STRUCTURE } from '../roster.api';

@Injectable()
export class GarageRosterStructureRepository extends RosterStructureRepository<Structure> {
  readonly #dataAccess = inject(ApiDataAccess);

  async load(params: LoadRosterStructureParams): Promise<Structure> {
    const location: ApiResourceLocation = {
      path: SOFTLINE_API_GARAGE_ROSTER_STRUCTURE,
      pathParams: { employeeId: params.employeeId },
      queryParams: {
        begindate: params.begindate,
        enddate: params.enddate,
      },
    };

    return this.#dataAccess.get(location);
  }
}
